export function parseConfig(config, fallbackValue) {
    try {
        return JSON.parse(config);
    } catch (error) {
        return fallbackValue ?? error;
    }
}

export function parseConfigArray(config, fallbackValue = []) {
    const parsedConfig = parseConfig(config, fallbackValue);

    return Array.isArray(parsedConfig) ? parsedConfig : fallbackValue;
}
